import { createContext, useContext } from "react";
import type { ApiConfig } from "./types";

export const ApiContext = createContext<ApiConfig>({});

export const useApiConfig = () => useContext(ApiContext);
